import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form1.css'
import { loadLocationWithMessage } from '../../../actions/location'

import '../../../styles/assets/css/pages/stepper1.css'
import { registration_steps } from '../variables/registration.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import SignatureCanvas from 'react-signature-canvas'

class ExecutiveFunctionCoaching extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
        status: false,
        status_submit: true,
        message: '',
        uid: 0,
        patient_date: new Date().toISOString().substring(0, 10),
        consented: -1,
        patient_name: '',
        pn_name: '',
      }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: escapeHtml(e.target.value),
    })
  }

  handleChange2 = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  componentDidMount() {
    this.getPatientInfo()
  }

  getPatientInfo = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/additional_program/check_consent_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { pid: this.props.authReducer.uid, consent_id: 1 }
    })
    .then((result) => {
      if(result['data'].consent == -1) {

      } else if (result['data'].consent == 1) {
        // redirect to PDF file //
        this.props.history.push('/member/consent/executive_function_coaching')
      } else {
        // consent == 2, show message //
        this.setState ({ consented: 2 })
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    // signature //
    var signature = this.refs.mySignature //.getCanvas()
    if(signature.isEmpty()) {
      this.setState({
        message: 'Please sign your signature',
      })
      window.scrollTo(0, 0)
    } else if(this.state.patient_name == '') {
      this.setState({
        message: 'Please provide your name',
      })
      window.scrollTo(0, 0)
    } else if(this.state.pn_name == '') {
      this.setState({
        message: 'Please provide your patient navigator/coach',
      })
      window.scrollTo(0, 0)
    } else {
      this.setState({
        status_submit: false,
        message: '',
      })

      var base64img = signature.toDataURL("image/png")
      const formData = new FormData()
      formData.append('file', base64img)
      formData.append('uid', this.props.authReducer.uid)
      formData.append('patient_date', this.state.patient_date)
      formData.append('udata', JSON.stringify(this.state))

      axios({
        method: 'post',
        url: connectNode + 'patient/additional_program/update_consent_efc',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        body: JSON.stringify(this.state),
        data: formData
      })
      .then((result) => {
        if(result['data'] === 'completed') {
          this.props.onLoadLocation('/member/patient_contract_list')
          this.props.history.push('/member/patient_contract_list')
        }
      })
    }
  }

  render() {
    return (
      <div className="patient_waiver patient_efc box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Executive Functioning Coaching
          </div>
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>}
        { this.state.consented === -1 && <div className="row">
          <div className="small-12 columns box1">
            <div className="">
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="small-12 columns">
                    <div className="white_bg1">
                      <p><b>About Executive Functioning Coaching</b></p>
                      <p>As part of the FITT-BD program, you are being offered the opportunity to participate in executive functioning coaching. Coaching is an additional service that supplements your current FITT-BD care. Participating in coaching does not replace or change the treatment and support you are already receiving through FITT-BD.</p>
                      <p>The purpose of executive functioning coaching is to help you develop and practice practical skills that can make your day-to-day tasks easier to manage. Coaching will focus on applying the skills you are learning to your own individual needs, situations, and circumstances so that you can identify strategies that are practical and useful in your daily life.</p>
                      <p>Participation in executive functioning coaching is voluntary. You may choose not to participate or may stop participating at any time. Choosing not to participate or deciding to stop coaching will not affect the other FITT-BD care you receive.</p>
                      <p><b>What to Expect</b></p>
                      <p>Executive functioning coaching will consist of five sessions, with coaching sessions occurring once per week. Each session will focus on specific executive functioning skills and practical strategies that you can apply in your daily life.</p>
                      <p>As part of coaching, you will be given brief take-home assignments or exercises to complete between sessions. These activities are intended to give you an opportunity to practice the strategies discussed with your coach and determine how they work for you in your everyday life.</p>
                      <p><b>Role of the Coach</b></p>
                      <p>Executive functioning coaching is provided by bachelor’s-level staff members who are not licensed mental health clinicians. </p>
                      <p>Coaches are trained to provide education, support, and guidance related to executive functioning skills. <span className="grey_highlight1">Coaches will be supervised by licensed clinical psychologists. If any issues or concerns arise that are outside the scope of the coaches’ training or experience, they will have access to these clinicians for consultation and guidance.</span></p>
                      <p>Coaches do not provide psychotherapy, clinical assessments or diagnoses, medication recommendations or management, treatment-change recommendations, or crisis and emergency mental health services.</p>
                      <p>If your coach becomes concerned about your safety or believes that additional clinical support may be needed, they may contact an appropriate member of the FITT-BD clinical team. The clinical team can then help determine whether any additional assessment, support, or follow-up is needed.</p>
                      <p><b>Consent to Participate</b></p>
                      <p>By signing below, I confirm that I understand the purpose and scope of executive functioning coaching, including the role of the coach, and that coaching is an additional service that supplements rather than replaces my regular FITT-BD care.</p>
                      <p>I have had the opportunity to ask questions about executive functioning coaching and voluntarily agree to participate.</p>
                    </div>
                  </div>
                </div>
                <div className="row signature top_space1">
                  <div className="small-12 medium-6 columns show-for-medium">&nbsp;</div>
                  <div className="small-12 medium-6 columns">
                    <div className="relative_float_left">
                      <TextField label="Please provide patient name"
                      name="patient_name" onChange={(e) => this.handleChange(e)}
                      variant="outlined" inputProps={{ maxLength: 30 }}  />
                    </div>
                    <div className="row title_signature">
                      <div className="small-6 columns">
                        Patient Signature
                      </div>
                      <div className="small-6 columns align-right">
                        <button type="button" className="clear_button"
                           onClick={ () => this.refs.mySignature.clear() }>
                            Clear
                        </button>
                      </div>
                    </div>
                    <div className="relative_float_left">
                        <SignatureCanvas penColor='#555555' canvasProps={{className: 'signatureCanvas'}}
                         ref="mySignature" />
                    </div>
                    <div className="relative_float_left">
                      <TextField label="Please provide patient navigator/Coach"
                      name="pn_name" onChange={(e) => this.handleChange(e)}
                      variant="outlined" inputProps={{ maxLength: 30 }}  />
                    </div>
                    <div className="relative_float_left top_space1">
                    <span className="bold">Date:</span> {this.state.patient_date}
                    {/*<TextField id="patient_date" label="Date" onChange={this.handleChange2} variant="outlined" type="date" defaultValue={this.state.patient_date}
                    InputProps={{ inputProps: { name: "patient_date", min: new Date().toISOString().substring(0, 10) }}} />*/}
                    </div>
                  </div>
                </div>



            </form>
          </div>
        </div>
        <div className="small-12 columns align_right">
          {this.state.status_submit &&
            <Button variant="contained" color="primary" disableElevation
             onClick={this.handleSubmit} type="submit" className="submit_1">
              Submit
          </Button>}
        {!this.state.status_submit &&
          <Button variant="contained" disabled
           onClick={this.handleSubmit} type="submit" className="submit_1">
            Submit
        </Button>}
        </div>
        </div>}
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ExecutiveFunctionCoaching)
